module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.hotel) ? _c('el-menu', {
    staticClass: "nav h100",
    attrs: {
      "router": true,
      "default-active": "2",
      "collapse": _vm.isCollapse,
      "background-color": _vm.hotel.colors.primary,
      "text-color": "#fff",
      "active-text-color": "#fff"
    },
    on: {
      "open": _vm.handleOpen,
      "close": _vm.handleClose
    }
  }, [_c('div', {
    staticClass: "grid logo"
  }, [(_vm.isCollapse) ? _c('el-menu-item', {
    on: {
      "click": function($event) {
        _vm.isCollapse = false
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-bars"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Apri menu")])]) : _vm._e(), _vm._v(" "), (!_vm.isCollapse) ? _c('el-menu-item', {
    on: {
      "click": function($event) {
        _vm.isCollapse = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-bars"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Chiudi menu")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "grid actions"
  }, [(_vm.hotels.length > 1) ? _c('el-submenu', {
    attrs: {
      "index": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fas fa-random"
  }), _vm._v(" "), (!_vm.isCollapse) ? _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Hotels")]) : _vm._e()]), _vm._v(" "), _c('el-menu-item-group', [_vm._l((_vm.hotels), function(hotel, index) {
    return (hotel.beachtype === 'grid') ? _c('el-menu-item', {
      key: index,
      attrs: {
        "index": '/ombrelli/' + hotel._id
      },
      on: {
        "click": function($event) {
          return _vm.changeHotel(hotel)
        }
      }
    }, [_vm._v(_vm._s(hotel.name))]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.hotels), function(hotel, index) {
    return (hotel.beachtype === 'canvas') ? _c('el-menu-item', {
      key: index,
      attrs: {
        "index": '/Canvas/' + hotel._id
      },
      on: {
        "click": function($event) {
          return _vm.changeHotel(hotel)
        }
      }
    }, [_vm._v(_vm._s(hotel.name))]) : _vm._e()
  })], 2)], 2) : _vm._e(), _vm._v(" "), (_vm.hotel.beachtype === 'grid') ? _c('el-menu-item', {
    attrs: {
      "index": '/ombrelli/' + _vm.hotel._id
    }
  }, [_c('i', {
    staticClass: "fas fa-th"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Spiaggia " + _vm._s(_vm.hotel.name))])]) : _vm._e(), _vm._v(" "), (_vm.hotel.beachtype === 'canvas') ? _c('el-menu-item', {
    attrs: {
      "index": '/Canvas/' + _vm.hotel._id
    }
  }, [_c('i', {
    staticClass: "fas fa-umbrella-beach"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), (_vm.pool) ? _c('el-menu-item', {
    attrs: {
      "index": '/Pool/' + _vm.hotel._id
    },
    on: {
      "click": _vm.editpool
    }
  }, [_c('i', {
    staticClass: "fas fa-wrench"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Edit Canvas")])]) : _vm._e(), _vm._v(" "), (_vm.pool) ? _c('el-menu-item', {
    attrs: {
      "index": '/Pool/' + _vm.hotel._id
    },
    on: {
      "click": _vm.addpool
    }
  }, [_c('i', {
    staticClass: "fas fa-swimming-pool"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Add Pool")])]) : _vm._e(), _vm._v(" "), (_vm.pool) ? _c('el-menu-item', {
    attrs: {
      "index": '/Pool/' + _vm.hotel._id
    },
    on: {
      "click": _vm.addombrid
    }
  }, [_c('i', {
    staticClass: "fas fa-umbrella-beach"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Add Ombrello")])]) : _vm._e(), _vm._v(" "), (_vm.canvas) ? _c('el-menu-item', {
    attrs: {
      "index": '/Canvas/' + _vm.hotel._id
    },
    on: {
      "click": _vm.editCanvas
    }
  }, [(!_vm.edit) ? _c('i', {
    staticClass: "fas fa-wrench"
  }) : _vm._e(), _vm._v(" "), (_vm.edit) ? _c('i', {
    staticClass: "fas fa-save"
  }) : _vm._e(), _vm._v(" "), (!_vm.edit) ? _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Imposta spiaggia")]) : _vm._e(), _vm._v(" "), (_vm.edit) ? _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Salva Impostazioni")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.canvas && _vm.edit) ? _c('el-menu-item', {
    attrs: {
      "index": '/Canvas/' + _vm.hotel._id
    },
    on: {
      "click": _vm.addombrid
    }
  }, [_c('i', {
    staticClass: "fas fa-umbrella-beach"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Agiungi ombrello")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "grid footer"
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/addhotel"
    }
  }, [_c('i', {
    staticClass: "fas fa-plus-square"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Aggiungi Hotel")])]), _vm._v(" "), _c('el-menu-item', {
    on: {
      "click": _vm.settings
    }
  }, [_c('i', {
    staticClass: "fas fa-cog"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Impostazioni " + _vm._s(_vm.hotel.name))])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/logout"
    }
  }, [_c('i', {
    staticClass: "fas fa-power-off"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Log Out")])])], 1)]) : _vm._e(), _vm._v(" "), _c('settings', {
    attrs: {
      "hotel": _vm.hotel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81ee76d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 657
// module chunks = 1